import { render, staticRenderFns } from "./ScheduleStudent.vue?vue&type=template&id=dc8f6c38&scoped=true&"
import script from "./ScheduleStudent.vue?vue&type=script&lang=js&"
export * from "./ScheduleStudent.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleStudent.vue?vue&type=style&index=0&id=dc8f6c38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8f6c38",
  null
  
)

export default component.exports